import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { SigninComponent } from './signin/signin.component';
import { authenticationRoutingModule } from './authentication-routing.module';
import { SharedAppModule } from '../app.module.shared';

import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { UnlockLoginComponent } from 'app/authentication/unlock-login/unlock-login.component';


@NgModule({
    declarations: [
        SigninComponent,
        ResetPasswordComponent,
        UnlockLoginComponent
    ],
    imports: [
        CommonModule,
        SharedAppModule,
        authenticationRoutingModule,
        ReactiveFormsModule,
        FormsModule
    ]
})
export class AuthenticationModule { }

